module.exports = __webpack_public_path__ + "img/decori_interni.97e7b551.jpg";